/* global $:true */
import debug from "debug";

import plugin from '../../lib/plugin';
import store from '@vendor/store/store';

const MODULE_NAME = 'app.core/modules/accept-cookie';
const log = debug(MODULE_NAME);



class AcceptCookiePlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$trigger = this.$element.find(this.options.triggerSelector);
        this.store = options.store;
        if (typeof options.store === 'string') {
            this.store = window[options.store];
        }

        log('AcceptCookiePlugin', element);
        this.remember();
        this.watch();
    }

    onClick () {
        log('clicked', this.$element);
        this.accept();
    }

    watch () {
        this.$trigger.on('click', this.onClick.bind(this));
    }

    unwatch () {
        this.$trigger.off('click', this.onClick);
        log('unbound', this.$element);
    }

    remember() {
        const state = this.store.read();
        if (state.includes(this.options.id)) {
            this.hide();
        } else {
            this.show();
        }
    }

    hide () {
        this.$element.addClass(this.options.successClass);
    }

    show () {
        this.$element.removeClass(this.options.successClass);
    }

    accept () {
        const url = `${this.options.endpointUrl}?${this.options.endpointParam}=${this.options.id}`;
        log('accepting', this.$element, url);
        $.ajax({
            url,
            success: () => {
                const {id} = this.options;
                this.hide();
                this.store.save({id});
            }
        })
        .done(() => {
            log('accepted', this.$element, url);
        });
    }

}

AcceptCookiePlugin.DEFAULTS = {
    endpointUrl: $(`meta[name="site.cookiesApiEndpoint"]`).attr('content'),
    endpointParam: 'guid',
    triggerSelector: 'button',
    successClass: 'accept-cookie--success',
    store: {
        read () {
            return store.get('accept-cookie') || [];
        },
        save ({id}) {
            const state = this.read();
            state.push(id);
            store.set('accept-cookie', state);
        }
    }
};


plugin('acceptCookie', AcceptCookiePlugin);

export function exec () {
    $(document).ready(() => {
        log('binding');
        $("[data-accept-cookie]").acceptCookie();
        log('bound');
    });
}





// WEBPACK FOOTER //
// ./client/src/core/modules/accept-cookie/index.js